import { getSOCReportDownload } from './API';

const GetSOCReportFile = async (fileName, accessToken) => {
  try {
    const response = await getSOCReportDownload(fileName, accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    const errorMsg = !!error.response?.data ? error.response.data?.message : 'Error: API call to retrieving SOC report file failed.';
    return { success: false, data: errorMsg};
  }
};

export default GetSOCReportFile;